import OneTNPage from './OneTNPage';
export default OneTNPage;
